function getLanguageFromCookie(cookieHeader) {
  const rawCookie = String(cookieHeader || '')
  const match = rawCookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith('app-language='))

  if (!match) return null

  try {
    const value = decodeURIComponent(match.slice('app-language='.length))
    return value === 'fr' || value === 'en' ? value : null
  } catch (err) {
    return null
  }
}

module.exports = {
  getLanguageFromCookie,
}
